export function createAuthGuards({ store }) {
  async function ensureAuth(to, from, next, redirectIfLogged = false) {
    if (store.state.user?.id) {
      return next(redirectIfLogged ? "/dashboard" : undefined);
    }

    const protectedRoute = isProtectedRoute(to);

    if (protectedRoute && !store.state.authChecked) {
      try {
        await store.dispatch("loginUserByToken");
        if (store.state.user?.id) {
          return next(redirectIfLogged ? "/dashboard" : undefined);
        }
      } catch (e) {
        // ignore
      }
    }

    if (redirectIfLogged) return next();
    return next("/login");
  }

  const middlewareAuth = (to, from, next) => ensureAuth(to, from, next);
  const middlewareGuest = (to, from, next) => ensureAuth(to, from, next, true);

  function isProtectedRoute(to) {
    return to.matched.some((r) => r.meta?.requiresAuth === true);
  }

  const ensureRole =
    (allowedRoles = []) =>
    (to, from, next) => {
      const role = store?.state?.user?.adminRole;
      if (allowedRoles.includes(role)) return next();
      return next({ name: "NotFound" });
    };

  const middlewareStoreAdmin = ensureRole(["owner", "dev", "adm"]);
  // const middlewareOwnerOnly = ensureRole(["owner"]);

  return {
    ensureAuth,
    middlewareAuth,
    middlewareGuest,
    isProtectedRoute,
    ensureRole,
    middlewareStoreAdmin,
  };
}
